import React from 'react';
import Box from '@mui/material/Box';
import {colors, fontSize, overlay} from '@/styles/tokens';

const STAR_COUNT = 5;

const starsWrapSx = {
    position: 'relative',
    display: 'inline-block',
    flexShrink: 0,
    fontSize: fontSize[12],
    lineHeight: 1,
    letterSpacing: '1px'
} as const;

const starsEmptySx = {color: overlay.whiteLight} as const;

const starsFilledSx = {
    position: 'absolute',
    inset: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    color: colors.accent.starYellow
} as const;

/**
 * Five stars with a fractional overlay clipped to the score, so 4.8 reads as 4.8
 * rather than a rounded-up five. Decorative — the score itself is rendered as text
 * beside it, so the stars are hidden from screen readers.
 */
const ReviewStarRating = ({rating, color}: {rating: number; color?: string}) => (
    <Box component="span" sx={starsWrapSx} aria-hidden="true">
        <Box component="span" sx={starsEmptySx}>
            {'★'.repeat(STAR_COUNT)}
        </Box>
        <Box component="span" sx={{...starsFilledSx, ...(color ? {color} : {}), width: `${(rating / STAR_COUNT) * 100}%`}}>
            {'★'.repeat(STAR_COUNT)}
        </Box>
    </Box>
);

export default ReviewStarRating;
